<template>

  <vx-card>

    <div class="vx-row">
      <div class="vx-col w-1/2">
        <h5> {{ $t('vdo-set.vdo-set-unit') }} </h5>
      </div>

      <div class="vx-col w-1/2">
        <vx-tooltip :text="$t('general.edit') + $t('vdo-set.vdo-set-unit')" class="float-right">
          <feather-icon @click="onEditClick" class="cursor-pointer float-right" icon="EditIcon"
                        svgClasses="w-5 h-5 hover:text-primary stroke-current"/>
        </vx-tooltip>
      </div>

    </div>

    <vs-divider/>

    <!-- Display VdoSetUnit Data -->
    <div class="vx-row" v-if="!showEditVdoSetUnitsForm">
      <div class="vx-col w-full mb-2">
        <ValidationProvider :name="$t('vdo-set.vdo-set-unit')" rules="required" v-slot="{ errors }">
          <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    :disabled="isUploading"
                    :name="$t('vdo-set.vdo-set-unit')"
                    :options="vdoSetUnits"
                    @input="onVdoSetUnitChange"
                    class="w-full mb-1"
                    label="unitSeq"
                    selectOnTab
                    v-model="vdoSetUnitEdit.selectedVdoSetUnit">

            <template #selected-option="{ unitSeq, courseOutlineUnit }">
              {{ unitSeq }}. {{ courseOutlineUnit.nameLocal}}
            </template>
            <!--option list-->
            <template v-slot:option="option">
              {{ option.unitSeq }}. {{ option.courseOutlineUnit.nameLocal}}
              <span class="float-right">
                ({{ option.vdoSetTopics.length + ' ' + $t('vdo-set.vdo-set-topic-short') }}
                {{ getTotalVdoQty(option) + ' ' + $t('vdo-set.vdo') }}
                {{ $t('vdo-set.total-vdo-length') + ' ' + formatVdoLength(option.totalVdoLength) }}
                | {{ $t('vdo-set.status') }}: {{ option.status === 'enable' ? $t('vdo-set-topic.is-enabled') : $t('vdo-set-topic.disabled') }}
                )
              </span>
            </template>

          </v-select>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>
    </div>

    <div class="vx-row text-center" v-if="!showEditVdoSetUnitsForm">
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <span>
          <p :class="totalTopicQty === 0 ? 'text-danger':''" class="text-l font-semibold">
              {{ totalTopicQty }}
          </p>
          <span class="font-medium text-grey">{{ $t('vdo-set.vdo-set-topic-qty') }}</span>
        </span>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <span>
          <p :class="totalVdoQty === 0 ? 'text-danger':''" class="text-l font-semibold">
            {{ totalVdoQty }}
          </p>
          <span class="font-medium text-grey">{{ $t('vdo-set.vdo-qty') }}</span>
        </span>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <span>
          <p :class="totalVdoLength === '00:00:00' ? 'text-danger':''" class="text-l font-semibold">
            {{ totalVdoLength }}
          </p>
          <span class="font-medium text-grey">{{ $t('vdo-set.total-vdo-length') }}</span>
        </span>
      </div>
      <div class="vx-col sm:w-1/4 w-full mb-2">
        <span>
          <p :class="unitStatus === 'enable' ? 'text-success':'text-danger'" class="text-l font-semibold">
            {{ unitStatus === 'enable' ? $t('vdo-set-topic.is-enabled') :$t('vdo-set-topic.disabled') }}
          </p>
          <span class="font-medium text-grey">{{ $t('vdo-set.status') }}</span>
        </span>
      </div>
    </div>

    <!-- Edit VdoSetUnit Form -->
    <div v-if="showEditVdoSetUnitsForm">
      <div class="vx-row">
        <div class="vx-col sm:w-1/3 w-full">
          <label class="text-sm">{{$t('vdo-set.vdo-set-unit')}}</label>
          <vs-textarea :value="vdoSetUnitName" disabled readonly rows="3"/>
        </div>
        <div class="vx-col sm:w-1/3 w-full">
          <label class="text-sm">{{$t('vdo-set.remark')}}</label>
          <vs-textarea rows="3"
                       v-model="vdoSetUnitForm.vdoSetUnitInput.remark"/>
        </div>

        <div class="vx-col sm:w-1/3 w-full">
          <div class="vx-row mt-5 mb-3">
            <div class="vx-col sm:w-1/2">
              <span class="flex items-center">
                <feather-icon icon="BookOpenIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                <span
                  class="ml-2 inline-block font-semibold">{{ $t('vdo-set.vdo-set-topic') }}</span>
              </span>
            </div>
            <div class="vx-col sm:w-1/2 text-right">
              <span :class="totalTopicQty === 0 ? 'text-danger':''">
                {{ totalTopicQty }}
              </span>
            </div>
          </div>
          <div class="vx-row mb-3">
            <div class="vx-col sm:w-1/2">
              <span class="flex items-center">
                <feather-icon icon="VideoIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                <span
                  class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-qty') }}</span>
              </span>
            </div>
            <div class="vx-col sm:w-1/2 text-right">
              <span :class="totalVdoQty === 0 ? 'text-danger':''">
                {{ totalVdoQty }}
              </span>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col sm:w-1/2">
              <span class="flex items-center">
                <feather-icon icon="FilmIcon" svgClasses="h-5 w-5 stroke-current text-primary"></feather-icon>
                <span
                  class="ml-2 inline-block font-semibold">{{ $t('class-room.course-outline-vdo-sets-total-length') }}</span>
              </span>
            </div>
            <div class="vx-col sm:w-1/2 text-right">
              <span :class="totalVdoLength === '00:00:00' ? 'text-danger':''">
                {{ totalVdoLength }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row mb-3">
        <div class="vx-col sm:w-1/3 w-full">
          <vs-switch  v-model="vdoSetUnitForm.vdoSetUnitInput.status">
            <span slot="on">{{$t('vdo-set-topic.is-enabled')}}</span>
            <span slot="off">{{$t('vdo-set-topic.disabled')}}</span>
          </vs-switch>
        </div>
      </div>

      <!-- Actions Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button :disabled="local.isProcessing || isUploading"
                     @click.prevent="onVdoSetUnitSaveClick">
            {{ $t('general.save') }}
          </vs-button>

          <vs-button @click.prevent="onVdoSetUnitCancelClick" class="ml-2" color="warning"
                     type="border">
            {{ $t('general.cancel') }}
          </vs-button>
        </div>
      </div>

    </div>

    <vs-divider/>

    <!-- VdoSetTopic -->
    <VdoSetTopicEdit/>


  </vx-card>

</template>

<script>
  import {state, setEmptyVdoSetTopicForm} from '../data';
  import vSelect from 'vue-select';
  import {secondToHHMMSSFormat} from "@/utils/data";
  import {showStateNotification} from "@/utils/notification";

  import VdoSetUnit from '@/store/modules/vdo-set/vdo-set/index';
  import {createNamespacedHelpers} from "vuex";
  import {createHelpers} from "vuex-map-fields";
  import {isBunnyUpload} from '@/utils/video-provider';
  import {hasVideo} from '@/utils/video-source';

  if (!state.store.VdoSetUnit) state.registerModule(`VdoSetUnit`, VdoSetUnit);

  const {
    mapActions: mapVdoSetUnitActions,
  } = createNamespacedHelpers(`VdoSetUnit`);

  const {
    mapFields: mapVdoSetUnitFields,
  } = createHelpers({
    getterType: `VdoSetUnit/getField`,
    mutationType: `VdoSetUnit/updateField`,
  });

  export default {
    components: {
      vSelect,
      // The one edit to an existing file in Phase 1. Something has to choose
      // which screen to load; reverting is an env change plus this line.
      VdoSetTopicEdit: () => isBunnyUpload()
        ? import('./VdoSetTopicEditBunny')
        : import('./VdoSetTopicEdit'),
    },
    data() {
      return {
        store: state.store,
        local: state.local,
        vdoSetEdit: state.local.vdoSetEdit,
        vdoSetInfo: state.local.vdoSetInfo,
        vdoSetUnitEdit: state.local.vdoSetUnitEdit,
        vdoSetUnitForm: state.local.vdoSetUnitEdit.form,

        showEditVdoSetUnitsForm: false,
        showEditForm: false,
      }
    },
    computed: {
      ...mapVdoSetUnitFields({
        vdoSetUnitProcessing: 'processing',
        vdoSetUnitSuccess: 'success',
        vdoSetUnitError: 'error'
      }),
      isUploading() {
        return this.local.isUploading;
      },
      vdoSetUnits() {
        return this.vdoSetInfo.selectedVdoSet ? this.vdoSetInfo.selectedVdoSet.vdoSetUnits : [];
      },
      vdoSetUnitName() {
        return this.vdoSetUnitEdit.selectedVdoSetUnit.unitSeq + '. ' + this.vdoSetUnitEdit.selectedVdoSetUnit.courseOutlineUnit.nameLocal;
      },
      totalTopicQty() {
        if (this.vdoSetUnitEdit.selectedVdoSetUnit) {
          return this.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics ? this.vdoSetUnitEdit.selectedVdoSetUnit.vdoSetTopics.length : 0;
        } else {
          return 0
        }
      },
      totalVdoQty() {
        return this.getTotalVdoQty(this.vdoSetUnitEdit.selectedVdoSetUnit);
      },
      totalVdoLength() {
        let totalVdoLength = '00:00:00';
        if (this.vdoSetUnitEdit.selectedVdoSetUnit) {
          totalVdoLength = secondToHHMMSSFormat(this.vdoSetUnitEdit.selectedVdoSetUnit.totalVdoLength);
        }
        return totalVdoLength;
      },
      unitStatus() {
        if (this.vdoSetUnitEdit.selectedVdoSetUnit) {
          return this.vdoSetUnitEdit.selectedVdoSetUnit.status
        }
        return '';
      }
    },
    watch: {
      vdoSetUnitProcessing(data) {
        this.local.isProcessing = data;
      },
      vdoSetUnitSuccess(data) {
        showStateNotification(this.$vs, data);
      },
      vdoSetUnitError: async function (data) {
        showStateNotification(this.$vs, data);
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//
      ...mapVdoSetUnitActions({
        getVdoSetUnitsByFilter: 'getVdoSetUnitsByFilter',
        updateVdoSetUnit: 'updateVdoSetUnit',
      }),
      //---------------------------------------- Event Function ------------------------------------------------------//
      onEditClick() {
        this.vdoSetUnitForm.vdoSetUnitInput.remark = this.vdoSetUnitEdit.selectedVdoSetUnit.remark;
        this.vdoSetUnitForm.vdoSetUnitInput.status = this.vdoSetUnitEdit.selectedVdoSetUnit.status === 'enable';
        this.toggleShowEdiVdoSetUnitForm();
      },
      onVdoSetUnitChange() {
        setEmptyVdoSetTopicForm();
      },
      async onVdoSetUnitSaveClick() {
        let payload = {
          id: this.vdoSetUnitEdit.selectedVdoSetUnit.id,
          teacherId: this.vdoSetEdit.courseOutline.teacher.id,
          vdoSetUnitInput: {
            remark: this.vdoSetUnitForm.vdoSetUnitInput.remark,
            status: this.vdoSetUnitForm.vdoSetUnitInput.status ? 'enable':'disable'
          }
        }
        let result = await this.updateVdoSetUnit(payload);

        if (result) {
          //update list
          this.updateListAfterSave(result);

          this.toggleShowEdiVdoSetUnitForm();
        }

      },
      onVdoSetUnitCancelClick() {
        this.toggleShowEdiVdoSetUnitForm();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      updateListAfterSave(result) {
        //deep copy so we can mutate data
        result = JSON.parse(JSON.stringify(result));
        //update vdoSet list
        const index = this.vdoSetInfo.selectedVdoSet.vdoSetUnits.findIndex(item => item.id === result.id);
        this.vdoSetInfo.selectedVdoSet.vdoSetUnits[index] = result;

        //set selected item
        this.vdoSetUnitEdit.selectedVdoSetUnit = result;
      },
      toggleShowEdiVdoSetUnitForm() {
        this.showEditVdoSetUnitsForm = !this.showEditVdoSetUnitsForm;
      },
      formatVdoLength(duration) {
        let totalVdoLength = '00:00:00';
        if (duration) {
          totalVdoLength = secondToHHMMSSFormat(duration);
        }
        return totalVdoLength;
      },
      // hasVideo, not vdoStreamPath: a Bunny upload never writes that column,
      // so this used to report 0 videos for a unit whose topics all had one --
      // next to a working play button and a real totalVdoLength.
      getTotalVdoQty(selectedVdoSetUnit) {
        let totalVdoQty = 0;
        if (selectedVdoSetUnit) {
          selectedVdoSetUnit.vdoSetTopics.forEach((vdoTopic) => {
            totalVdoQty += hasVideo(vdoTopic) ? 1 : 0;
          });
        }
        return totalVdoQty;
      }
    },
  }

</script>

<style scoped>

</style>
